import { z } from "zod";
import { automationRunStatusSchema } from "./automationRun.js";
const threadChunkStreamEventSchema = z.object({
  type: z.literal("chunk"),
  thread_id: z.string(),
  chunk: z.unknown()
});
const threadEndStreamEventSchema = z.object({
  type: z.literal("thread_end"),
  thread_id: z.string()
});
const automationRunStreamEventSchema = z.discriminatedUnion("type", [
  threadChunkStreamEventSchema,
  threadEndStreamEventSchema,
  z.object({
    type: z.literal("thread_reset"),
    thread_id: z.string()
  }),
  z.object({
    type: z.literal("run_status"),
    status: automationRunStatusSchema
  })
]);
export {
  automationRunStreamEventSchema,
  threadChunkStreamEventSchema,
  threadEndStreamEventSchema
};
//# sourceMappingURL=automationRunStream.js.map
